@if (isComic(comicOrMangaItem) || isManga(comicOrMangaItem)) {
<header class="bg-white dark:bg-black-dark mb-2">
  <div class="flex justify-between items-center pr-0 h-[38px] mb-3">
    <h2
      class="!mt-0 !mb-0 !ml-0 max-sm:!max-w-[60%] max-mobile:pl-5 max-mobile:pr-0"
    >
      {{ "MY_READING_DATES" | translate }}
    </h2>
    <button class="btn btn-small" (click)="saveAllDates()">
      {{ submitText }}
    </button>
  </div>
</header>
<div
  class="overflow-y-scroll max-h-[calc(100vh-(var(--sab)+var(--sat))-135px)] mobile:max-h-[440px] max-mobile:mt-3"
>
  @for ( progress of comicOrMangaItem.progress?.volumes; track
  trackByNumber($index, progress)) {
  <div class="mb-3 pr-2">
    <div>
      <span class="capitalize font-bold"
        >{{ "VOLUME" | translate }} {{ progress.volume }}</span
      >
      @if (getVolumeTitle(progress.volume) !== '') { :
      {{ getVolumeTitle(progress.volume) }}
      }
    </div>
    <app-edit-work-completion-dates
      [item]="comicOrMangaItem"
      [volume]="progress"
      (dateChange)="handleDateChange($event)"
    ></app-edit-work-completion-dates>
  </div>
  }
</div>
}
